import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(`
    width:100%;
    position:relative;

    & svg .tick text {
        fill: #000c !important;
    }
`)

export const ToolTip = styled(Box)(`
    position: fixed;
    z-index: 10;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    font-size: 13px;
    margin: 10px 0 0 10px;
    display:none;
`)

export const ToolTipWrapper = styled(Box)(`
    position: absolute;
    display: none;
    padding: 5px;
    z-index: 10;
    // border: '2px solid black';
    border-radius: 4px !important;
    background: #fff; // Apply color based on d prop or fallback

    &.tooltipPosiLeft > div:before {
        left: auto;
        right: -25px;
        top: 10px;
        border-left-color: #fff;
        border-right-color: transparent;
    }
`)

export const CustomAxisX = styled(Box)(`
    position: absolute;
    z-index: 1;
    width: calc(100% - 39px);
    height: 20px;
    bottom: 20px;
    left: 39px;
    z-index: 1;
    padding: 3px 8px 0 8px;
    display: flex;
    justify-content: space-between;
    color: #000c;
    border-top: 1px #EFEFEF solid;

    & span{
        line-height: 13px;
        text-align: center;
        width: 100%;
        display: inline-block;
    }
`)

export const NoDataFound = styled(Box)(`
	position: absolute;
	right:0;
	top: calc(50% - 41px);
	z-index:1;
	padding:8px;
	background:#FCF7D4;
	max-width:173px;
	border-radius: 4px 0px 0px 4px;
	& b::before { content:'i'; width:16px; height:16px; border: 1px #000 solid; line-height:16px; border-radius:50%; display:inline-block; margin-right:5px; font-size:11px;  font-weight: 400; }
	& b { font-size: 14px; font-weight: 400; text-align: center;}
	& p { font-size: 11px; font-weight: 400; line-height:13px; padding-top:5px;}
`)
